import React from 'react';

export default function BlockVideo({ block }) {
 

    let src = block.src;
    let isYoutube = false;
    let videoId = null;

    if(src && src.includes('youtube')){
        isYoutube = true;
        // Extract the YouTube video ID from the iframe src attribute
        if(src.includes('youtube.com/embed/')){
            videoId = src.split('embed/')[1].split('?')[0]; // Remove any query parameters
        }else{
            const match = src.match(/youtube\.com\/embed\/([a-zA-Z0-9_-]+)/);
            if (match && match[1]) {
                videoId = match[1];
            }
        }
        
    } 

      
    return (
        <div className="rounded-xl bg-white w-full">
            <div
                className="relative w-full"
                style={{
                    paddingBottom: "56.25%", // 16:9 aspect ratio
                    height: 0,
                    overflow: "hidden",
                    borderRadius: "0.75rem",
                    background: "#000",
                }}
            >
                {isYoutube && videoId ? (
                    <iframe
                        className="absolute top-0 left-0 w-full h-full"
                        src={`https://www.youtube.com/embed/${videoId}`}
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowFullScreen
                        style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                        }}
                    />
                ) : (
                    <div
                        className="absolute top-0 left-0 w-full h-full"
                        dangerouslySetInnerHTML={{ __html: src }}
                    />
                )}
            </div>
        </div>
    );
}